/**
 * Query keys centralizzate per le query TanStack Query relative al controllo pulizie.
 * Usa questa struttura per garantire invalidazione consistente della cache.
 */
export const cleaningQueryKeys = {
  all: ['cleaning'] as const,
  byDate: (date: string) => ['cleaning', 'by-date', date] as const,
  calendar: (from: string, to: string) => ['cleaning', 'calendar', from, to] as const,
  areaHistory: (areaId: string, from: string | null, to: string | null) =>
    ['cleaning', 'area-history', areaId, from, to] as const,
};
